import { StyleShadowRoot } from "@redotech/react-util/style";
import { DeliveryEstimate as DeliveryEstimateType } from "@redotech/redo-model/conversion/conversion-autocheck";
import { IpifyGeoClientProvider } from "@redotech/redo-web/ipify";
import { ModalRootContext } from "@redotech/redo-web/modal-root";
import { memo } from "react";
import STYLE_MANAGER from "../../style-manager";
import { DateEstimateProvider } from "./date-estimate-context";
import { DeliveryEstimate } from "./delivery-estimate";
import { useRenderPdps } from "./use-render-pdps";
import { ZipCodeProvider } from "./zip-code-context";

export const DeliveryEstimateInitializer = memo(
  function DeliveryEstimateInitializer({
    deliveryEstimateSettings,
  }: {
    deliveryEstimateSettings: DeliveryEstimateType;
  }) {
    const pdpPortals = useRenderPdps(deliveryEstimateSettings);

    const ipifyApiKey =
      globalThis.redoStorefront?.env?.IPIFY_API_KEY ??
      process.env.IPIFY_API_KEY;
    if (!ipifyApiKey) {
      console.error("IPIFY_API_KEY is not set");
      return null;
    }

    const storeUrl =
      globalThis.redoStorefront?.storeUrl ?? globalThis.Shopify?.shop;
    if (!storeUrl) {
      console.error("storeUrl is not set");
      return null;
    }

    if (pdpPortals.length > 0) {
      return (
        <IpifyGeoClientProvider apiKey={ipifyApiKey}>
          <ZipCodeProvider>
            <DateEstimateProvider storeUrl={storeUrl}>
              {pdpPortals.map(({ foundSelector, portal }, index) => (
                <StyleShadowRoot
                  key={index}
                  shadowRoot={portal.root}
                  styleManager={STYLE_MANAGER}
                >
                  <ModalRootContext.Provider value={portal.modalContainer}>
                    <DeliveryEstimate />
                  </ModalRootContext.Provider>
                </StyleShadowRoot>
              ))}
            </DateEstimateProvider>
          </ZipCodeProvider>
        </IpifyGeoClientProvider>
      );
    }

    return null;
  },
);
